import React, { Component } from "react";
import CustomerListComponent from "../../components/Customers/CustomerListComponent";

class CustomerList extends Component {
  render() {
    return (
      <div>
        <CustomerListComponent />
      </div>
    );
  }
}

export default CustomerList;
